/**
 * A count as a number to show. A missing or non-numeric value is 0: during a
 * deploy the new frontend can talk to a backend that does not send the field
 * yet, and "undefined open tasks" on screen is worse than saying nothing.
 */
export function asCount(value: unknown): number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : 0;
}

/** "1 note", "2 notes". The one place a count and its noun are joined. */
export function plural(count: number, one: string, other: string): string {
  const n = asCount(count);
  return `${n} ${n === 1 ? one : other}`;
}
